module.exports = __webpack_public_path__ + "static/media/millionairequiz.0199e4f6.png";